import React from 'react';
import {
  GlobalAccessContainer,
  GlobalAccessStyled,
} from './GlobalAccess.styles';
import { StyledRadioButton } from '../../Steps/AccessStep.styles';

interface GlobalAccessProps {
  globalAccess: boolean;
  onClick: () => void;
  children: React.ReactNode;
  disabled?: boolean;
  'data-testid'?: string;
}

export const GlobalAccess = ({
  globalAccess,
  onClick,
  children,
  disabled = false,
  ...props
}: GlobalAccessProps) => {
  return (
    <GlobalAccessStyled globalAccess={globalAccess} disabled={disabled}>
      <StyledRadioButton
        id={'editor-access-radio'}
        onClick={onClick}
        checked={globalAccess}
        data-testid={props['data-testid']}
        disabled={disabled}
      />
      <GlobalAccessContainer>{children}</GlobalAccessContainer>
    </GlobalAccessStyled>
  );
};
